import { COLORS } from '@/config/colors';
import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

export const dialog: {
  defaultProps?: ComponentsProps['MuiDialog'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiDialog'];
  variants?: ComponentsVariants<Theme>['MuiDialog'];
} = {
  styleOverrides: {
    root({ theme }) {
      return {
        '.MuiPaper-root': {
          background: theme.palette.background.default,
          border: 'solid 1px',
          borderColor: COLORS.grey[800],
          borderRadius: '8px',

          // Les 119 dialogues de l'application ont été dessinés pour une
          // fenêtre de bureau : aucun ne déclare `fullScreen`, et la largeur
          // par défaut de MUI (`sm`, 600px) déborde d'un téléphone. Plutôt que
          // d'aller les toucher un par un, on les contraint ici. La hauteur
          // reste automatique : une confirmation de deux lignes ne doit pas
          // occuper tout l'écran sous prétexte qu'on est sur mobile.
          [theme.breakpoints.down('md')]: {
            margin: 12,
            width: 'calc(100% - 24px)',
            maxWidth: 'calc(100% - 24px)',
            maxHeight:
              'calc(100% - 24px - var(--safe-top) - var(--safe-bottom))',
          },
        },
      };
    },
  },
};

export const dialogContent: {
  defaultProps?: ComponentsProps['MuiDialogContent'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiDialogContent'];
  variants?: ComponentsVariants<Theme>['MuiDialogContent'];
} = {
  styleOverrides: {
    root({ theme }) {
      return {
        '&.MuiDialogContent-root': {
          padding: '1rem',
          // Sur 390px de large, 2rem de gouttières mangent un sixième de la
          // ligne de texte.
          [theme.breakpoints.down('md')]: {
            padding: '0.75rem',
          },
        },
      };
    },
  },
};

export const dialogTitle: {
  defaultProps?: ComponentsProps['MuiDialogTitle'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiDialogTitle'];
  variants?: ComponentsVariants<Theme>['MuiDialogTitle'];
} = {
  styleOverrides: {
    root() {
      return {
        background: '#16161a',
        borderBottom: '1px solid rgba(255,255,255,0.05)',
      };
    },
  },
};

export const dialogActions: {
  defaultProps?: ComponentsProps['MuiDialogActions'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiDialogActions'];
  variants?: ComponentsVariants<Theme>['MuiDialogActions'];
} = {
  styleOverrides: {
    root({ theme }) {
      return {
        background: theme.palette.grey[950],
        borderTop: 'solid 1px',
        borderColor: theme.palette.grey[800],
      };
    },
  },
};
